import React from "react";
import { BrowserRouter as Router, Route, Link } from "react-router-dom";
import logo from './logo.svg';
import './App.css';
import 'tachyons';

const CustomLinkExample = () => (
  <Router >
    <div>
      <div>
        <ul className="tr shadow-hover">
           <li className="nav"><OldSchoolMenuLink activeOnlyWhenExact={true} to="/" label="home" /></li>
           <li className="nav"><OldSchoolMenuLink to="/projects" label="projects" /></li>
           <li className="nav"><OldSchoolMenuLink to="/about" label="about" /></li>
         </ul>
      </div>    
       <div className="mh4">
          <Route exact path="/" component={Home} />
          <Route path="/projects" component={Projects} />
          <Route path="/about" component={About} />
        </div>
      </div>
  </Router>
);

const OldSchoolMenuLink = ({ label, to, activeOnlyWhenExact }) => (
  <Route
    path={to}
    exact={activeOnlyWhenExact}
    children={({ match }) => (
      <div className={match ? "active" : ""}>
        {match ? ">" : ""}
        <Link to={to}>{label}</Link>
      </div>
    )}
  />
);

const Home = () => (
<div className="App">
    <header className="App-header mv4">
      <img src={logo} className="App-logo" alt="logo" />
      <h1 className="heading">astronucleus</h1>
      <img src={logo} className="App-logoX" alt="logo" />
    </header>
<br/><br/><p>
    Two billion years ago, our ancestors were microbes;<br/><br/> 
    a half-billion years ago, fish;<br/><br/> 
    a hundred million years ago, something like mice;<br/><br/> 
    ten million years ago, arboreal apes;<br/><br/> 
    and a million years ago, proto-humans puzzling out to taming fire. <br/><br/> 
    Our evolututionary lineage is marked by mastery of change. <br/><br/> 
    In our time, the pace is quickening. <br/><br/><br/>
    -CARL SAGAN
</p>
</div>
);

const Projects = () => (
  <div>
    <h3 className="tc heading">Projects</h3>
    <p>
        Research Phase
        <ul>
            <li>Carbon Costing - a theoretical costing methodology that imposes the need of companies to record and report the effects of business transactions in depleting natural resources and its effects to climate change</li>
            <li>Multiplanetary value transfer system - evaluating the concept of multi-planetary exchange values and economics and use of onboard accounting systems implemented to asteroid mining robots or multi-planetary exploration projects</li>
        </ul>
    </p>
  </div>
);

const About = () => (
  <div className="App">
    <header className="App-header mv4">
      <img src={logo} className="App-logo1" alt="logo" />
      <h3 className="heading">astronucleus</h3>
      <img src={logo} className="App-logoX1" alt="logo" />
    </header>
    <h3>About</h3>
    <div className="">
      At Astronucleus, we make bold predictions and practical applications about the convergence of exponential technologies. <br/><br/>
      We track opportunities and possibilities in the next fifty years.<br/><br/>
      We fundamentally believe in achieving more through the use of technology and collaboration. 

      <br/><br/><br/><br/><br/><br/>
      We do innovation assessments..<br/>
      <a href="https://contactastronucleus@gmail.com">Contact us</a>
    </div>
  </div>  
);

export default CustomLinkExample;
